import React from 'react';
import { FieldError } from '@/ui';
import ComboBoxAutocomplete from '@/components/FormFields/ComboBoxAutocomplete';

export const AffiliateComboBox = ({ input, affiliates, busy, meta: { touched, error } }) => (
  <>
    <ComboBoxAutocomplete
      name={input.name}
      options={affiliates}
      value={input.value}
      valueField='id'
      textField={(item) => (typeof item === 'string' ? item : item.name)}
      busy={busy}
      placeholder='Select Affiliate'
      onChange={(value) => input.onChange(typeof value === 'string' ? value : value?.name)}
      onBlur={() => input.onBlur(input.value)}
      groupBy={(item) => (item?.name?.startsWith('#') ? 0 : 1)}
      renderListGroup={({ group }) => (group === 0 ? <span>Tags</span> : <span>Affiliates</span>)}
      error={Boolean(touched && error)}
    />
    <FieldError error={error} touched={touched} />
  </>
);
